import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

const CANONICAL_ORIGIN = 'https://www.askiitians.com';

@Injectable({ providedIn: 'root' })
export class CanonicalService {
  constructor(@Inject(DOCUMENT) private dom: Document) {}

  buildForumQuestionCanonical(questionLink?: string | null): string | null {
    if (!questionLink) return null;

    let path = String(questionLink).split(/[?#]/, 1)[0].trim();
    try {
      path = decodeURIComponent(path);
    } catch {
      return null;
    }

    path = path
      .replace(/\\/g, '/')
      .replace(/^\/+|\/+$/g, '')
      .replace(/\/+/g, '/')
      .toLowerCase();
    while (path.startsWith('forums/')) path = path.slice('forums/'.length);

    const hasQuestionId = /(?:_\d+\.htm|\/\d+\/[^/]+)$/i.test(path);
    if (!hasQuestionId || path.split('/').some((segment) => !segment || segment === '.' || segment === '..')) {
      return null;
    }

    const encodedPath = path.split('/').map((segment) => encodeURIComponent(segment)).join('/');
    return `${CANONICAL_ORIGIN}/forums/${encodedPath}`;
  }

  setCanonicalURL(url?: string | null): string {
    const supplied = String(url || this.dom.location?.pathname || '/');
    let pathname = '/';

    try {
      const parsed = new URL(supplied, CANONICAL_ORIGIN);
      pathname = parsed.pathname || '/';
    } catch {
      pathname = '/';
    }

    pathname = pathname.replace(/\/{2,}/g, '/').replace(/\/?forums\/forums\//i, '/forums/');
    if (!pathname.startsWith('/')) pathname = `/${pathname}`;

    const href = `${CANONICAL_ORIGIN}${pathname}`;
    const canonicalLinks = Array.from(this.dom.head.querySelectorAll('link[rel="canonical"]'));
    const link = (canonicalLinks.shift() as HTMLLinkElement | undefined) || this.dom.createElement('link');
    link.rel = 'canonical';
    link.href = href;
    this.dom.head.appendChild(link);
    canonicalLinks.forEach((duplicate) => duplicate.remove());
    return href;
  }

  clearCanonicalURL(): void {
    this.dom.head.querySelectorAll('link[rel="canonical"]').forEach((link) => link.remove());
  }

  setSchema(schemaData?: string | null): void {
    this.dom.head.querySelectorAll('script[type="application/ld+json"]').forEach((script) => script.remove());
    if (!schemaData) return;

    const script = this.dom.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = schemaData;
    this.dom.head.appendChild(script);
  }
}
